import { format, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const DEFAULT_LOCALE_SETTINGS = {
  timeZone: 'Africa/Dakar',
  dateFormat: 'dd/MM/yyyy',
  dateTimeFormat: 'dd/MM/yyyy HH:mm',
  timeFormat: 'HH:mm'
};

let activeSettings = { ...DEFAULT_LOCALE_SETTINGS };

function toDate(value) {
  if (value == null || value === '') return null;
  const dateObj = typeof value === 'string' ? parseISO(value) : value;
  if (!(dateObj instanceof Date) || Number.isNaN(dateObj.getTime())) return null;
  return dateObj;
}

function formatInConfiguredZone(date, pattern) {
  const dateObj = toDate(date);
  if (!dateObj) return '';
  const tz = activeSettings.timeZone || DEFAULT_LOCALE_SETTINGS.timeZone;
  const fmt = pattern || DEFAULT_LOCALE_SETTINGS.dateFormat;
  try {
    return formatInTimeZone(dateObj, tz, fmt);
  } catch {
    return formatInTimeZone(dateObj, DEFAULT_LOCALE_SETTINGS.timeZone, fmt);
  }
}

export function getLocaleSettings() {
  return { ...activeSettings };
}

export function setLocaleSettings(next) {
  if (!next || typeof next !== 'object') return;
  activeSettings = {
    timeZone: next.timeZone || DEFAULT_LOCALE_SETTINGS.timeZone,
    dateFormat: next.dateFormat || DEFAULT_LOCALE_SETTINGS.dateFormat,
    dateTimeFormat: next.dateTimeFormat || DEFAULT_LOCALE_SETTINGS.dateTimeFormat,
    timeFormat: next.timeFormat || DEFAULT_LOCALE_SETTINGS.timeFormat
  };
}

export function formatDate(date, pattern) {
  return formatInConfiguredZone(date, pattern || activeSettings.dateFormat);
}

/** Format API date keys (yyyy-MM-dd) without timezone shift. */
export function formatDateKey(dateKey, pattern) {
  if (dateKey == null || dateKey === '') return '';
  const match = String(dateKey).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return formatDate(dateKey, pattern);
  const [, y, mo, d] = match;
  const dateObj = new Date(Number(y), Number(mo) - 1, Number(d));
  const fmt = pattern || activeSettings.dateFormat || DEFAULT_LOCALE_SETTINGS.dateFormat;
  return format(dateObj, fmt);
}

export function formatDateTime(date, pattern) {
  return formatInConfiguredZone(date, pattern || activeSettings.dateTimeFormat);
}

export function formatTime(date, pattern) {
  return formatInConfiguredZone(date, pattern || activeSettings.timeFormat);
}
